import {Component, Input, Output, EventEmitter} from '@angular/core';

import 'style-loader!./ubiMenuItem.scss';

@Component({
  selector: 'ubi-menu-item',
  templateUrl: './ubiMenuItem.html'
})
export class UbiMenuItem {

  @Input() menuItem:any;
  @Input() child:boolean = false;

  @Output() itemHover = new EventEmitter<any>();
  @Output() toggleSubMenu = new EventEmitter<any>();

  public onHoverItem($event):void {
    this.itemHover.emit($event);
  }

  public onToggleSubMenu($event, item):boolean {
    $event.item = item;
    this.toggleSubMenu.emit($event);
    return false;
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiMenu/components/ubiMenuItem/ubiMenuItem.component.ts